<template>
  <div class="header">
    <div class="title cl">
      <h1 class="fl">
        <a href="https://www.yilieyun.com" title="易猎云招聘管理系统">
        <img
          @click="gotohome"
          class="img100 homelogo"
          src="https://img.yilieyun.cn/tenant-logo/48/2023/companyLogo_1204112135.png"
          alt=""
        />
      </a>
      </h1>
      <ul class="nav fl">
        <router-link
          active-class="active"
          v-for="(item, index) in navData"
          :key="index"
          :to="{ path: item.path, query: routeData }"
          :class="{
            active_s: pathname.includes('/media') && item.name === '关于我们'
            ||pathname.includes('/coverage/1') && item.name === '关于我们'
            ||pathname.includes('/coverage/2') && item.name === '关于我们'
            ||pathname.includes('/coverage/3') && item.name === '关于我们'
            ||pathname.includes('/coverage/4') && item.name === '关于我们'
            ||pathname.includes('/coverage/5') && item.name === '关于我们'
            ||pathname.includes('/coverage/6') && item.name === '关于我们'
            ||pathname.includes('/coverage/7') && item.name === '关于我们'
            ||pathname.includes('/coverage/8') && item.name === '关于我们'
            ||pathtext=='/'&&item.name === '首页'
            ||pathtext=='/price'&&item.name === '价格'
            ||pathtext=='/learning'&&item.name === '学习中心'
            ||pathtext=='/product'&&item.name === '产品'
            ||pathtext=='/large'&&item.name === '产品'
            ||pathtext=='/mobile'&&item.name === '产品'
            ||pathtext=='/about'&&item.name === '关于我们'
            ||pathtext=='/media'&&item.name === '关于我们'

          }"
          style="position: relative;"
          :style="{width:item.name=='产品'?'80px':''}"
          @click.native="gotochild(item.path)"
          v-show="index<5"
        >
          <span @mouseenter="down_box(item.name)">{{ item.name }} </span>
          <span  @mouseenter="down_box(item.name)" v-show="item.name=='产品'" :class="visible==true ? 'dropshow':'drop_box'">
            <img v-show="index==1"   class="icon_down" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_down_al.png"/>
          </span>
            <div v-show="index==1&&visible" class="small_lx"></div>
        </router-link>
        <div  v-show="visible" @mouseenter="down_box()"  @mouseleave="down_box_close()" class="poper_box">
          <a href="/product" >RPO招聘管理系统</a>
          <a href="/hr" >HR招聘管理系统</a>
          <a href="/outsource" >外包管理系统</a>
          <a href="/wecom" >企微助手</a>
          <a href="/ordering" >渠道及发单平台</a>
          <a href="/mobile" >易猎云工作手机</a>
          <a href="/ecall" >易外呼APP</a>
        </div>
      </ul>
      <div class="hotline fr cl">
        <img
          src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_telephone@2x.png"
        />
        <span class="tel">400-0588-036</span>
        <!-- <span class="ontrial" @click="trial" v-show="!name">免费开通</span> -->
        <span @click="showLoginType()" class="login" v-show="!name">登录</span>
        <span class="login_name" v-show="name" @click="todoats()">{{name&&name.length>5?name.substring(0,4):name}}</span>
        <span class="login_name2" @click="backout()" v-show="name">退出</span>
      </div>
    </div>
    <!--申请试用组件-->
    <populone :isshow="windowflags" :he="false" @handleChange="changewindows" />
    <login v-if="showLogin"></login>
    <div v-show="visible" @click="()=>visible=false" class="bigbox" ></div>
  </div>
</template>

<script>
import populone from "@/components/views/popul/populone";
import login from "@/components/views/login/index.vue";
import { boo } from "../../../tool/apiboo";

export default {
  data() {
    return {
      visible:false,
      visible2:false,
      windowflags: false,
      navData: [
        { name: "首页", path: "/" },
        { name: "产品", path: "/product" },
        //{ name: "产品", path: "/large" },
        { name: "价格", path: "/price" },
        { name: "学习中心", path: "/learning" },
        { name: "关于我们", path: "/about" },
        { name: "媒体报道", path:"/media"},
        { name: "1",path:"/coverage/1"},
        { name: "2",path:"/coverage/2"},
        { name: "3",path:"/coverage/3"},
        { name: "4",path:"/coverage/4"},
        { name: "5",path:"/coverage/5"},
        { name: "6",path:"/coverage/6"},
        { name: "7",path:"/coverage/7"},
        { name: "8",path:"/coverage/8"},
      ],
      pathname: window.location.pathname,
      showLogin: false,
      activePath: "",
      routeData: {},
      pathtext:'/',
      lastout:'',
      name:''
    };
  },
  components: {
    populone,
    login,
  },
  beforeCreate(){
   if(this.$route.query.type==1){
     sessionStorage.setItem('path','/price');
   }
  },
  mounted() {
   this.handleRouteChange(); // 页面初次加载时也执行一次
    this.name=localStorage.getItem('name')||'';
    this.$eventBus.$on("loginModel", (param) => {
      this.showLogin = param;
      this.name=localStorage.getItem('name');
    });
    setInterval(()=>{
      this.name=localStorage.getItem('name');
    },2000)
  },
  watch: {
    immediate:true,
        deep: true,
        $route(to, from){
          this.handleRouteChange();
        },

    },
  methods: {
    //重新写
    handleRouteChange(){
      const { fullPath, path, query, params } = this.$route;

  // 1. 平台产品跳转识别
  if (params.id === '2') {
    this.pathtext = '/large';
    if (path !== '/large/2') {
      this.$router.replace({ path: '/large/2' }); // 替换而不是 push，避免重复历史
    }
    return;
  }

  // 2. hr 产品
  if (params.id === 'hr') {
    this.pathtext = '/product';
    if (path !== '/hr/') {
      this.$router.replace({ path: '/hr/' });
    }
    return;
  }

  // 3. 移动端登录传参跳转
  if (query.mobileobject) {
    try {
      const mobileobj = JSON.parse(query.mobileobject);
      const { profile, access_token, playedu_token } = mobileobj;
      const { name, versionsStatus, domain } = profile;
      localStorage.setItem('name', name);
      localStorage.setItem('versionsStatus', versionsStatus);
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('playedu_token', playedu_token);
      localStorage.setItem('domanUrl', domain);
      localStorage.setItem('userinfo', JSON.stringify(mobileobj));
      this.pathtext = '/product';
      if (path !== '/mobile') {
        this.$router.replace({ path: '/mobile' });
      }
    } catch (e) {
      console.error('mobileobject 解析失败', e);
    }
    return;
  }

  // 4. 学习中心传参（不跳转，仅存储）
  if (query.learnobj) {
    try {
      const learn = JSON.parse(query.learnobj);
      const { profile, access_token, playedu_token } = learn;
      const { name, versionsStatus, domain } = profile;
      localStorage.setItem('name', name);
      localStorage.setItem('versionsStatus', versionsStatus);
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('playedu_token', playedu_token);
      localStorage.setItem('domanUrl', domain);
      localStorage.setItem('userinfo', JSON.stringify(learn));
      this.pathtext = '/product';
    } catch (e) {
      console.error('learnobj 解析失败', e);
    }
    return;
  }

  // 5. pathtext 映射规则
  const map = {
    '/': '/',
    '/product': '/product',
    '/outsource': '/product',
    '/hr': '/product',
    '/wecom': '/product',
    '/mobile': '/product',
    '/ecall': '/product',
    '/ordering': '/product',
    '/about': '/about',
    '/media': '/about',
    '/learning': '/learning',
    '/price': '/price',
  };
  const cleanPath = path.replace(/\/$/, '') || '/'; // 去掉末尾 /，但保留根路径 '/'
  this.pathtext = map[cleanPath] || '';
  console.log(this.$route.fullPath, '新的方法执行');
    },
    gotohome() {
      this.$router.push({
        path: "/",
        query: this.routeData,
      });

      if (this.activePath !== "/about") this.pathname = "";
      document.documentElement.scrollTop = 0;
    },
    gotochild(path) {
      this.pathname=window.location.pathname;
      this.activePath = path;
      if (path !== "/about") this.pathname = "";
      document.documentElement.scrollTop = 0;
    },
    trial() {
      this.windowflags = true;
    },
    changewindows(value) {
      this.windowflags = value;
    },
    showLoginType() {
      this.showLogin = true;
      localStorage.setItem('learntype','2');
    },
    down_box(name){
      if(name=='产品'){
        this.visible=true;
      }
    },
    down_box_close(){
      console.log("离开了");
      clearInterval(this.lastout);
      this.lastout= setTimeout(() => {
        this.visible=false;
      }, 300);
    
    },
    // todoproduct(val){
    //   if(val=='1'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       path: "/product",
    //     });
    //   }else if(val=='2'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       path: "/product/hr",
    //     });
    //   }else if(val=='3'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       name: "Productoutsource",
    //     });
    //   }else if(val=='4'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       name: "Productwecom",
    //     });
    //   }else if(val=='5'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       name: "Productordering",
    //     });
    //   }else if(val=='6'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       name: "Productecall",
    //     });
    //   }else if(val=='7'){
    //     this.pathtext='/product'
    //     this.visible=false;
    //     this.$router.push({
    //       name: "Productmobile",
    //     });
    //   }

    // },
    backout(){
      localStorage.removeItem("name");
      localStorage.removeItem("versionsStatus");
      localStorage.removeItem("access_token");
      localStorage.removeItem("playedu_token");
      localStorage.removeItem("domanUrl");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("ClientBrowseIds");
    },
    todoats(){
     let domanUrl= localStorage.getItem('domanUrl');
     let userinfo= localStorage.getItem('userinfo');
     var cbid= localStorage.getItem("ClientBrowseIds", "");
     let newuser=JSON.parse(userinfo);
     newuser.ClientBrowseId=cbid;
     let {playedu_token, ...newObj} = newuser;
     console.log( "https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(newObj));
     window.open(
            "https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(newObj)
          );
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
@import "~@/assets/css/style/config.less";

.header {
  width: 100%;
  min-width: 100vw;
  height: 85px;
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  background: #ffffff;
  border-bottom: solid 2px #e4ecff;

  .title {
    padding-top: 14px;
    width: 1490px;
    height: 105px;
    margin: 0 auto;
    font-size: 20px;
    // background:red;
    h1 {
      width: 199px;
      height: 54px;
    }

    .homelogo {
      cursor: pointer;
    }

    .nav {
      position: relative;
      padding-top: 13px;
      width: 770px;
      height: 68px;
      margin-left: 68px;

      a {
        cursor: pointer;
        display: inline-block;
        margin-right: 78px;
        font-size: 24px;
        font-weight: 600;
        color: #405374;
      }

      a:last-child {
        margin-right: 0;
      }
    }

    .hotline {
      position: relative;
      width: 432px;
      height: 81px;
      padding-left: 0;

      img {
        position: absolute;
        display: inline-block;
        width: 27px;
        height: 30px;
        top: 12px;
      }

      .tel {
        display: inline-block;
        height: 30px;
        color: #405374;
        font-size: 22px;
        margin-left: 38px;
        margin-top: 17px;
      }

      .ontrial {
        position: absolute;
        display: inline-block;
        width: 114px;
        height: 50px;
        background: #fb983c;
        border-radius: 7px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        right: 110px;
      }

      .login {
        float: right;
        cursor: pointer;
        width: 95px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #deefff;
        border-radius: 7px;
        border: 1px solid #0084ff;
        color: #0084ff;
        margin-right: 100px;
      }
      .login_name{
        display: inline-block;
        cursor: pointer;
        width: 105px;
        height: 50px;
        line-height: 50px;
        text-align: right;
        margin-left: 20px;
       
      }
      .login_name2{
        display: inline-block;
        cursor: pointer;
        width: 85px;
        height: 50px;
        line-height: 50px;
        text-align: left;
        color: #0084ff;
        margin-left: 10px;
      }
    }
  }
}

.active_s_s {
}

.active {

}

.active_s {
  padding-bottom: 32px;
  border-bottom: solid 4px #0084ff;
  color: #0084ff;
}
.icon_down{
 
}
.poper_box{
  position: absolute;
  min-width: 203px;
  background-color: #ffffff;
  border-radius: 12px;
  top: 60px;
  left: 115px;
  box-shadow: -1px 2px 15px 0px #E2EDFF;
  padding: 20px 0px;
  z-index: 1000;
  a{
    display: block !important;
    font-size: 18px !important;
    height: 40px !important;
    line-height: 40px !important;
    padding-left: 30px !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
  }
  a:hover{
    color: #0084ff !important;
   // background: #DCEEFF !important;
  }
}
.small_lx{
  position: absolute;
  width: 0;
  height: 0;
  left: 64px;
  top: 33px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #ffffff;
 
}
.bigbox{
  position: fixed;
  left: 0;
  top: 50px;
  right: 0;
  bottom: -1000px;
  z-index: 999;
}
.drop_box{
  display:inline-block; 
  width: 40px;
  height: 100px;
  position: absolute;
  left: 60px;
}
.dropshow{
  display:inline-block; 
  width: 140px;
  height: 280px;
  position: absolute;
  left: 60px;
}
</style>





// WEBPACK FOOTER //
// src/components/views/header/index.vue